<template>
  <div>
    <!-- 修改邮箱 -->
    <el-dialog title="更换邮箱" width="398px" :visible.sync="updateShow" @close="cancel" destroy-on-close :close-on-click-modal="false" :modal-append-to-body="false">
      <section class="dialogContent">
        <p class="hint">
          使用邮箱验证身份，解绑后将无法使用该邮箱登录此账号，现在邮箱：<span class="blue">{{mail | addStar('mail')}}</span>
        </p>
        <el-form :model="updateMailForm" :rules="mailRules" ref="checkMail">
          <el-form-item prop="captcha">
            <el-input v-model="updateMailForm.captcha" maxlength="6" placeholder="请输入验证码">
              <el-button slot="suffix" @click="getMailCode(12)" type="text" class="inputSuffix" :loading="timeRemaining==60&&!allow" :disabled="!allow">{{timeRemaining==60?'获取验证码':'重新获取'+timeRemaining}}</el-button>
            </el-input>
          </el-form-item>
        </el-form>
      </section>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="cancel">取 消</el-button>
        <el-button size="medium" type="primary" @click="checkEmail" :loading="disableNext">下一步</el-button>
      </div>
    </el-dialog>
    <!-- 绑定邮箱 -->
    <el-dialog title="绑定邮箱" :visible.sync="bindShow" width="398px" @close="cancel" destroy-on-close :close-on-click-modal="false" :modal-append-to-body="false">
      <section class="dialogContent">
        <p class="hint">请输入您要绑定的邮箱地址，绑定后即可用该邮箱登录所有爱原物产品</p>
        <el-form :model="bindMailForm" :rules="mailRules" ref="bindMail" :hide-required-asterisk="true">
          <el-form-item label="邮箱" prop="mail">
            <el-input v-model="bindMailForm.mail" placeholder="请输入邮箱地址"></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="captcha">
            <el-input v-model="bindMailForm.captcha" maxlength="6" placeholder="请输入验证码">
              <el-button slot="suffix" @click="getMailCode(11)" type="text" class="inputSuffix" :loading="timeRemaining==60&&!allow" :disabled="!allow">{{timeRemaining==60?'获取验证码':'重新获取'+timeRemaining}}</el-button>
            </el-input>
          </el-form-item>
        </el-form>
      </section>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="cancel">取 消</el-button>
        <el-button size="medium" type="primary" @click="bindMail" :loading="subLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { bingMail, updateMail, checkMail } from "../../../api/accountManage"
import { mapGetters, mapActions } from "vuex";
import { mailVerify } from "../../../tool";
export default {
  props: {
    handlerType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      updateShow: false, // 更换显示
      bindShow: false, // 绑定显示
      updateMailForm: { // 更换邮箱验证
        captcha: null,
        captchaKey: null
      },
      mailRules: { // 邮箱表单验证
        mail: [{ validator: mailVerify, trigger: 'blur' }],
        captcha: [{ required: true, message: "请输入验证码", tarigger: "blur" }],
      },
      bindMailForm: { // 绑定邮箱表单
        mail: null,
        captcha: null,
        captchaKey: null
      },
      lastCaptchaKey: null,
      disableNext: false, // 下一步按钮
      subLoading: false, // 提交按钮
    }
  },
  computed: {
    ...mapGetters(["allow", "mail", "timeRemaining", "captchaKey"])
  },
  watch: {
    handlerType: {
      handler(val) {
        if (val === 1) {
          this.bindShow = true
        } else if (val === 2) {
          this.updateShow = true
        } else {
          this.bindShow = false
          this.updateShow = false
          if (this.$refs['checkMail']) {
            this.$refs['checkMail'].resetFields()
          }
          if (this.$refs['bindMail']) {
            this.$refs['bindMail'].resetFields()
          }
        }
      }
    },
    captchaKey(val) { // 图形验证后设置相应的 captchaKey
      if (this.handlerType === 1) {
        this.bindMailForm.captchaKey = val
      } else if (this.handlerType === 2) {
        this.updateMailForm.captchaKey = val
      }
    }
  },
  methods: {
    ...mapActions(["getCaptcha", "getUserInfo"]),
    // 取消
    cancel() {
      this.$emit("update:handlerType", 0)
    },
    // 获取邮箱验证码
    async getMailCode(captchaType) {
      let params = {
        mail: this.bindMailForm.mail,
        captcha: 'mail',
        type: captchaType // 11邮箱绑定，12邮箱更换前，13邮箱更换，14手机更换，15密码修改
      }
      if (this.handlerType === 1) { // 绑定邮箱
        this.$refs['bindMail'].validateField(('mail'), async (err) => {
          if (!err) {
            let { data } = await this.getCaptcha(params)
            if (data) {
              this.bindMailForm.captchaKey = data.captchaKey
            }
          }
        })
      } else { // 更换邮箱验证
        let { data } = await this.getCaptcha(params)
        if (data) {
          this.updateMailForm.captchaKey = data.captchaKey
        }
      }
    },
    // 验证邮箱
    checkEmail() {
      this.$refs["checkMail"].validate(async valid => {
        if (valid) {
          this.disableNext = true
          let { data } = await checkMail({ mail: this.mail, ...this.updateMailForm }).catch(() => {
            this.disableNext = false
          })
          if (data) {
            this.lastCaptchaKey = data
            this.$store.commit("RESET_SMS")
            this.$emit("update:handlerType", 1)
          }
          this.disableNext = false
        }
      })
    },
    // 绑定邮箱
    async bindMail() {
      this.$refs["bindMail"].validate(async valid => {
        if (valid) {
          this.subLoading = true
          if (this.lastCaptchaKey) {
            let res = await updateMail({
              lastCaptchaKey: this.lastCaptchaKey,
              ...this.bindMailForm
            }).catch(() => {
              this.subLoading = false
            })
            this.subLoading = false
            if (res.code === 1) {
              this.getUserInfo()
              this.$message({
                type: "success",
                message: "更换邮箱成功"
              })
              this.$emit("update:handlerType", 0)
            }
          } else {
            let res = await bingMail(this.bindMailForm).catch(() => {
              this.subLoading = false
            })
            this.subLoading = false
            if (res.code === 1) {
              this.getUserInfo()
              this.$message({
                type: "success",
                message: "绑定邮箱成功"
              })
              this.$emit("update:handlerType", 0)
            }
          }
        }
      })
    },
  }
}
</script>

<style>
</style>